import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ReuniaoCanDeactivate } from './reuniao-can-deactivate';
import Swal, { SweetAlertOptions } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class DirtycheckGuard implements  CanDeactivate<ReuniaoCanDeactivate> {

  canDeactivate(
    component: ReuniaoCanDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if(component.canDeactivate()){
      return true;
    }
    else{
      var msg = 'É possível que as alterações feitas não sejam salvas. Deseja sair sem salvar?';
      return new Observable<boolean>((observer) => {
        Swal.fire({
          title: '',
          text: msg,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sair',
          cancelButtonText: 'Cancelar',
          customClass: 'sw-system',
        } as SweetAlertOptions).then((result) => {
          if (result.isConfirmed) {
            observer.next(true);
          } else {
            observer.next(false);
          }
          observer.complete();
        });
      });
    }
  }
  
}
